define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityOwnerDomain = void 0;
    class FacilityOwnerDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityOwnerDomain.StateOwned, value: "State Owned" },
                    { key: FacilityOwnerDomain.PrivatelyOwned, value: "Privately Owned" },
                    { key: FacilityOwnerDomain.CouncilOwned, value: "Council Owned" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityOwnerDomain.StateOwned] = 0;
                this.KeyIndex[FacilityOwnerDomain.PrivatelyOwned] = 1;
                this.KeyIndex[FacilityOwnerDomain.CouncilOwned] = 2;
                this.ValueIndex = {};
                this.ValueIndex["State Owned"] = 0;
                this.ValueIndex["Privately Owned"] = 1;
                this.ValueIndex["Council Owned"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityOwnerDomain = FacilityOwnerDomain;
    Object.defineProperty(FacilityOwnerDomain, "StateOwned", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityOwnerDomain, "PrivatelyOwned", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityOwnerDomain, "CouncilOwned", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityOwnerDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
